import { Button, Center, Skeleton, Checkbox } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import SupervisionDataTableRowFormMeta from '@Modules/interfaceManagement/interface/containers/tableHandlers/supervision/SupervisionDatatableRowMeta';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TDataTableData = {
    primaryKey: string | number,
    identifier: string,
    name: string,
    lastUpTime: string,
    lastDownTime: string,
    status: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TDataTableData>()

export function getDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    columnHelper.accessor("identifier",
        {
            id: "identifier",
            header: "ID",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("name",
        {
            id: "nameId",
            header: "Nom",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("lastUpTime",
        {
            id: "lastUpTime",
            header: "Dernier UpTime",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("lastDownTime",
        {
            id: "lastDownTime",
            header: "Dernier DownTime",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "status",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {SupervisionDataTableRowFormMeta.status.options &&
                    SupervisionDataTableRowFormMeta.status.options.map((opt, i) => (
                        opt.value == props.getValue() && 
                        <span key={i}>{opt.label}</span>
                    ))}
                </Skeleton>)
            },
        }
    ),

    columnHelper.display(
        {
            id: "actionBtn",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                            <Button
                                size={'sm'}
                                onClick={() => handleEdit(props.row)}
                            >
                                Editer
                            </Button>
                            <Button
                                size={'sm'}
                                colorScheme='blue'
                            >
                                Lancer
                            </Button>
                            <Button
                                size={'sm'}
                                colorScheme='teal'
                            >
                                Arrêter
                            </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
